import { render } from "./웹진-건강플러스.vue?vue&type=template&id=5de0d6d9"
import script from "./웹진-건강플러스.vue?vue&type=script&lang=js"
export * from "./웹진-건강플러스.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__